const module = { name: 'fd-header.app', exports: {} }; const exports = module.exports;



import { default as globalSearch } from 'swug-fdRequire-call:fd-header/globalSearch';



import { default as locationDropdown } from 'swug-fdRequire-call:fd-header/locationDropdown';



import { default as locationFormCreation } from 'swug-fdRequire-call:fd-location/form/creation';

function init() {
    globalSearch.init();
    locationDropdown.init();
    locationFormCreation.init({
        trigger: '#brand-bar-location-btn',
        dropdown: {
            name: 'brandBarLocation',
            relativeParent: '#brand-bar',
        }
    });
}
document.addEventListener('DOMContentLoaded', init);
export default module.exports;